import React, { type ReactNode } from 'react'

type optionsType = {
	transparent?: boolean
	disabled?: boolean
}

type ButtonType = React.ComponentPropsWithoutRef<'button'> & {
	transparent?: boolean
	children?: ReactNode
}

type variantsType = Record<string, (className?: string, options?: optionsType | undefined) => typeof className | string>

const defaultClassName: string =
	'text-base border border-buttonBg font-bold px-7 h-12 bg-buttonBg text-white rounded-xl hover:bg-transparent dark:hover:text-white hover:text-buttonBg transition-colors'

function configOptions(options: optionsType | undefined): string {
	let className = ''
	if (options?.transparent) className += 'transparent '
	if (options?.disabled) className += options?.transparent ? 'bg-primary-100 ' : 'bg-primary-300 '
	return className
}

const variants: variantsType = {
	default: (className, options?) => `${defaultClassName} ${configOptions(options)} ${className || ''}`,
	small: (className, options?) => `${defaultClassName} ${configOptions(options)} ${className || ''}`,
	full: (className, options?) =>
		`${defaultClassName} hover:bg-primary-500 transition-colors w-full ${configOptions(options)} ${className || ''}`,
}

function DefaultBtn({ children, ...props }: React.ComponentPropsWithoutRef<'button'>): ReactNode {
	return <button {...props}>{children}</button>
}

export default function Button({ ...props }: ButtonType) {
	props.className = `${defaultClassName} rounded-2xl ${props.className || ''}`
	if ('transparent' in props) delete props.transparent
	return <DefaultBtn {...props} />
}
Button.Small = function SmallButton({ ...props }: ButtonType) {
	props.className = variants.small(`${props?.transparent ? variants.transparent(props?.className) : props?.className}`)
	if ('transparent' in props) delete props.transparent
	return <DefaultBtn {...props} />
}

Button.Full = function FullButton({ ...props }: ButtonType) {
	props.className = variants.full(props?.className, props)
	if ('transparent' in props) delete props.transparent
	return <DefaultBtn {...props} />
}
